enum ActionType {
    REQUEST_SELF_MONITORING_ENGINE_RULES = '[SELF MONITORING ENGINE RULES] REQUEST DATA',
    RECEIVED_SELF_MONITORING_ENGINE_RULES = '[SELF MONITORING ENGINE RULES] RECEIVE DATA',
}

export default ActionType
